import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import $ from 'jquery';

/* Actions */
import * as navactions from '../../actions/nav/index';

/* Components */
import NavComponent from '../../components/nav/';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const nav = this.props.history.location.pathname.replace('/dashboard/', '');
    $(window).on('popstate', function(e) {
      const urls = location.href.split('/');
      let els = document.querySelector(`[data-route='${urls[4]}'],[data-routeaux='${urls[4]}']`);
      if (els) {
        let type = els.dataset.type;
        let menu, box, submenu;
        if (type != 'menu') {
          menu = els.dataset.menusub;
          box = `sub${els.dataset.menusub}`;
          submenu = els.id;
          if (document.getElementById(submenu)) {
            const subs = document.querySelectorAll(`[data-menusub]`);
            for (let i = 0; i < subs.length; i++) {
              subs[i].classList.remove('active');
            }
            const menua = document.querySelectorAll(`[data-type]`);
            for (let e = 0; e < menua.length; e++) {
              menua[e].classList.remove('active');
            }
            const ok = document.querySelectorAll(`[data-ok="oksub"]`);
            for (let a = 0; a < ok.length; a++) {
              ok[a].classList.remove('active');
            }
            const submenuInput = document.getElementById(submenu);
            submenuInput.classList.add('active');
            if (els.dataset.menusub) {
              document.getElementById(els.dataset.menusub).classList.add('active');
              document.getElementById(box).classList.add('active');
            }
          }
        }
      }
    });
  }

  componentDidUpdate() {
    const nav = this.props.history.location.pathname.replace('/dashboard/', '');
    let els = document.querySelector(`[data-route='${nav}'],[data-routeaux='${nav}']`);

    if (els) {
      let type = els.dataset.type;
      let menu, box, submenu;
      if (type != 'menu') {
        menu = els.dataset.menusub;
        box = `sub${els.dataset.menusub}`;
        submenu = els.id;
        if (document.getElementById(menu)) {
          const menuInput = document.getElementById(menu);
          menuInput.classList.add('active');
        }
        if (document.getElementById(submenu)) {
          const submenuInput = document.getElementById(submenu);
          submenuInput.classList.add('active');
        }
        if (document.getElementById(box)) {
          const boxInput = document.getElementById(box);
          boxInput.classList.add('active');
        }
      } else {
        menu = els.id;
        if (document.getElementById(menu)) {
          const menuInput = document.getElementById(menu);
          menuInput.classList.add('active');
        }
      }
    }
  }

  handleNav = async event => {
    const obj = {
      route: ''
    };
    if (event.currentTarget.dataset.type == 'menu') {
    } else {
      const subs = document.querySelectorAll(`[data-menusub]`);
      const menu = document.querySelectorAll(`[data-type]`);
      const ok = document.querySelectorAll(`[data-ok="oksub"]`);

      for (let i = 0; i < subs.length; i++) {
        subs[i].classList.remove('active');
      }

      for (let e = 0; e < menu.length; e++) {
        menu[e].classList.remove('active');
      }

      for (let a = 0; a < ok.length; a++) {
        ok[a].classList.remove('active');
      }

      if (event.currentTarget.dataset.menusub) {
        document
          .getElementById(`sub${event.currentTarget.dataset.menusub}`)
          .classList.add('active');
        document.getElementById(event.currentTarget.dataset.menusub).classList.add('active');
      }
      event.currentTarget.classList.add('active');
      obj.route = `${event.currentTarget.dataset.route}`;
    }
  };

  render() {
    const language = this.props.language ? this.props.language.nav : '';

    return (
      <NavComponent
        status={this.props.status}
        language={language}
        handleNav={this.handleNav}
        handleChangeMenuState={this.props.handleChangeMenuState}
        menuCollapse={this.props.menuCollapse}
        setting={this.props.setting}
        showVersion={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(navactions, dispatch)
});

Nav.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav);



// WEBPACK FOOTER //
// ./source/client/containers/nav/index.jsx